import { types } from 'mobx-state-tree';

export const AccountModel = types.model({
    id: types.maybeNull(types.number),
    status: types.maybeNull(types.number),
    platformId: types.maybeNull(types.number),
    companyName: types.maybeNull(types.string),
    storeName: types.maybeNull(types.string),
    logoUrl: types.maybeNull(types.string)
});
